import { paddings } from 'core/styles';
import { device, typographyMobile } from 'core/styles/variables';
import styled from 'styled-components';

export const SalesCompanyCodesInformationDiv = styled.div`
  display: flex;
  align-items: center;
  gap: ${paddings.smallPadding};
  padding-bottom: ${paddings.mediumPadding};
  color: ${({ theme }) => theme.colors.brandPrimary};
  cursor: pointer;

  @media ${device.lg} {
    gap: ${paddings.mediumPadding};
  }
`;

export const SalesCompanyCodesGuideSpan = styled.span`
  width: fit-content;
  font-size: ${typographyMobile.size.tiny};

  @media ${device.lg} {
    font-size: ${typographyMobile.size.default};
    &:hover {
      text-decoration: underline;
      color: ${({ theme }) => theme.colors.orange600};
    }
  }
`;
